import TimeAgo from "react-timeago";
import { useNavigate } from "react-router-dom";
// import { ROUTING } from "../../utils/routes";
import NotificationAPI from "../../services/notification";

const shortFormatter = (value, unit, suffix, epochSeconds, nextFormatter) => {
  const units = {
    second: "s",
    minute: "m",
    hour: "h",
    day: "d",
    week: "w",
    month: "M",
    year: "y",
  };

  return `${value}${units[unit]} ago`;
};

const NotificationItem = ({ val, today }) => {
  const navigate = useNavigate();
  const { updateRead } = NotificationAPI();
  // const desc = JSON.parse(val?.description)?.roomId;

  const handleNoti = () => {
    if (val?.isRead === 0) {
      updateRead(val?.id)
        .then((e) => {
          console.log("updateRead e", e.data);
        })
        .catch((err) => {
          console.error("updateRead err", err);
        });
    }
    if (val?.url) {
      navigate(val.url);
      return;
    }
    // if (val?.isRead === 1 && !desc) return;
    // navigate(`${ROUTING.VIDEO_CONFERENCE}/${desc}`);
  };

  // const readNoti = (id, read) => {
  //   if (read === 1) return;
  //   updateRead(id)
  //     .then((e) => {
  //       console.log("updateRead e", e.data);
  //     })
  //     .catch((err) => {
  //       console.error("updateRead err", err);
  //     });
  // };

  return (
    <li
      className={`notiBox p-2 ${val?.isRead === 0 ? "unReadNoti" : "readNoti"}`}
    >
      <button
        className="dropdown-item p-0 bg-transparent border-0 w-100"
        onClick={handleNoti}
      >
        <p
          className={`m-0 ${
            val?.isRead === 0 ? "unReadNotiPara" : "readNotiPara"
          }`}
        >
          {val.title}
        </p>
        <small className="timeFormat text-muted">
          {today ? (
            <>
              {new Date(val?.addedat).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </>
          ) : (
            <TimeAgo date={val?.addedat} formatter={shortFormatter} />
          )}
        </small>
      </button>
    </li>
  );
};

export default NotificationItem;
